var _module_exports = "<div>\n    Computes the integral of the timeseries, multiplying the value by the time range (seconds) it\n    represents.\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/analytics/block/INTEGRATE/config.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;